import script from "./menu-single-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./menu-single-panel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__